import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewPrimehill',
  props: {
  bonuses: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props



return { __sfc: true,props }
}

})